/* eslint-disable */

if (!Array.prototype.map) {
  Array.prototype.map = function(callback, thisArg) {
    let T, A, k

    if (this == null) {
      throw new TypeError(' this is null or not defined')
    }

    // 1. 将O赋值为调用map方法的数组.
    const O = Object(this)

    // 2.将len赋值为数组O的长度.
    const len = O.length >>> 0

    // 4.如果callback不是函数,则抛出TypeError异常.
    if ({}.toString.call(callback) != '[object Function]') {
      throw new TypeError(callback + ' is not a function')
    }

    // 5. 如果参数thisArg有值,则将T赋值为thisArg;否则T为undefined.
    if (thisArg) {
      T = thisArg
    }

    // 6. 创建新数组A,长度为原数组O长度len
    A = new Array(len)

    // 7. 将k赋值为0
    k = 0

    // 8. 当 k < len 时,执行循环.
    while (k < len) {
      var kValue, mappedValue

      // 遍历O,k为原数组索引
      if (k in O) {
        // kValue为索引k对应的值.
        kValue = O[ k ]

        // 执行callback,this指向T,参数有三个.分别是kValue:值,k:索引,O:原数组.
        mappedValue = callback.call(T, kValue, k, O)

        // 返回值添加到新数组A中.
        A[ k ] = mappedValue
      }
      // k自增1
      k++
    }

    // 9. 返回新数组A
    return A
  }
}

if (!Array.prototype.filter) {
  Array.prototype.filter = function(fun /*, thisArg */) {
    'use strict'

    if (this === void 0 || this === null) { throw new TypeError() }

    const t = Object(this)
    const len = t.length >>> 0
    if (typeof fun !== 'function') { throw new TypeError() }

    const res = []
    const thisArg = arguments.length >= 2 ? arguments[1] : void 0
    for (let i = 0; i < len; i++) {
      if (i in t) {
        const val = t[i]

        // NOTE: Technically this should Object.defineProperty at
        //       the next index, as push can be affected by
        //       properties on Object.prototype and Array.prototype.
        //       But that method's new, and collisions should be
        //       rare, so use the more-compatible alternative.
        if (fun.call(thisArg, val, i, t)) { res.push(val) }
      }
    }

    return res
  }
}

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.com/#x15.4.4.18
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function forEach(callback, thisArg) {
    let T, k

    if (this == null) {
      throw new TypeError('this is null or not defined')
    }

    // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
    const O = Object(this)

    // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    const len = O.length >>> 0 // Hack to convert O.length to a UInt32

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if ({}.toString.call(callback) !== '[object Function]') {
      throw new TypeError(callback + ' is not a function')
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (thisArg) {
      T = thisArg
    }

    // 6. Let k be 0
    k = 0

    // 7. Repeat, while k < len
    while (k < len) {
      var kValue

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (Object.prototype.hasOwnProperty.call(O, k)) {
        // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
        kValue = O[ k ]

        // ii. Call the Call internal method of callback with T as the this value and
        // argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O)
      }
      // d. Increase k by 1.
      k++
    }
    // 8. return undefined
  }
}

Array.prototype.unique = function (key) {
  const obj = {}
  const arr = this
  const result = []
  for (let i = 0; i < arr.length; i++) {
    const value = arr[i]
    if (typeof value === 'string' || typeof value === 'number') {
      if (!obj[value]) {
        result.push(value)
      }
      obj[value] = value
    } else if (typeof value === 'object' && value.hasOwnProperty('length')) { // 数组
      result.push(value)
    } else if (key) { // key 相同被认为元素相同
      const objKey = value[key]
      if (!obj[objKey]) {
        result.push(value)
      }
      obj[objKey] = value
    }
  }
  return result
}

module.exports = Array



// WEBPACK FOOTER //
// ./src/js/infrastructure/Array.js